namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;

    export class AssignTagController {

        public cmd: AssigneeTagTasksCommand;

        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
            private minhasTarefasService: MinhasTarefasService,
            private tasks: ITask[], public tags: ITaskTag[]) {
            this.cmd = new AssigneeTagTasksCommand(tasks);
        }

        public addtagsTasks(): void {
            this.minhasTarefasService.setTagsTasks(this.cmd)
                .then(() => {
                    this.tasks.forEach(task => {
                        if (task.etags != null) {
                            task.etags.push(...this.cmd.tags);
                        } else {
                            task.etags = this.cmd.tags;
                        }
                    });
                    this.$mdDialog.hide();
                });
        }

        public closeDialog(): void {
            this.$mdDialog.hide();
        }
    }

    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.AssignTagController", AssignTagController);
}